/**
 * Human-readable payment status labels (distinct from operational order status keys).
 */
export function translatePaymentStatus(paymentStatus, t) {
  if (!paymentStatus) return '—';
  if (paymentStatus === 'paid') return t('admin_payment_paid');
  if (paymentStatus === 'pending') return t('admin_payment_pending');
  if (paymentStatus === 'failed') return t('admin_payment_failed');
  if (paymentStatus === 'cancelled') return t('cancelled');
  if (paymentStatus === 'invoiced') {
    return t('client_invoice_status_invoiced', { defaultValue: paymentStatus });
  }
  return t(paymentStatus, { defaultValue: paymentStatus });
}
